import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { EXTERNAL_HOST } from '../../../../ConsumerArea/ConsumerAreaConstants';
import { externalHostSelector as selectExternalHostSelector } from '../../../../ConsumerArea/ConsumerAreaSelector';
import { Dropdown } from '../../../Goals/components/Dropdown/Dropdown';
import { SUMMARY_OPTION } from '../../../Goals/components/Dropdown/useDropdown';
import { useFpId } from '../../../hooks/useFpId';
import { useShowAddGoal } from '../../hooks/useShowAddGoal';
import { useShowDownloadPdf } from '../../hooks/useShowDownloadPdf';

interface HeaderActionsProps {
  clientId: string;
}

export const HeaderActions = ({ clientId }: HeaderActionsProps) => {
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const showDownloadPDF = useShowDownloadPdf();
  const showAddGoal = useShowAddGoal();
  const fpId = useFpId();

  const externalHost = useSelector(selectExternalHostSelector);

  return (
    <Box display="flex" justifyContent="space-between" mb="40">
      <Box width={240}>
        <Dropdown defaultSelected={SUMMARY_OPTION} />
      </Box>

      {externalHost !== EXTERNAL_HOST.ELEMENT && (
        <>
          <Box display="flex" gridGap="8">
            {showDownloadPDF && (
              <Button
                variant="secondary"
                leftIcon="far fa-arrow-circle-down"
                isLoading={isGeneratingPDF}
                disabled={isGeneratingPDF}
                onClick={() =>
                  ADV.util.downloadPDF(
                    clientId,
                    fpId,
                    () => setIsGeneratingPDF(true),
                    () => setIsGeneratingPDF(false),
                  )
                }
              >
                Download PDF
              </Button>
            )}

            {showAddGoal && (
              <Button
                leftIcon="far fa-bullseye-arrow"
                onClick={() => ADV.util.Router.go2('ClientEditPlan', { clientId })}
              >
                Add Goal
              </Button>
            )}
          </Box>
        </>
      )}
    </Box>
  );
};
